angular.module('invoice')
    .component('invoiceTransfersForInvoice', {
        bindings: {
            invoiceId: '<',
            invoice: '<',
            onSettlementChanged: '&'
        },
        templateUrl: 'app/invoice/_transfers.html',
        controller: function ($scope, $state, Invoice, InvoiceService, InvoiceSettlement, InvoiceSettlementService, InvoiceConst, InvoiceSettlementConst) {
            this.$onInit = () => {
                Invoice.transfers({id: this.invoiceId}).$promise.then(items => this.transfers = items).catch(() => this.transfers = [])
            }

            this.addSettlement = () => InvoiceSettlementService.add(this.invoice)

            $scope.$on(InvoiceConst.eventUpdate, () => this.$onInit())
            $scope.$on(InvoiceSettlementConst.eventUpdate, () => {
                this.$onInit()
                this.onSettlementChanged()
            })
        }
    })
